import { computed } from 'mobx';
import { BaseSite, type AppCapabilities } from '@link/share/stores';
import siteApi from '@link/skytree/services/endpoints/site';

export class Site extends BaseSite implements AppCapabilities {
  // Skytree diverges from every other app on all of these: it ships its own
  // column UI, and its designs drop the notices, the trailing sold-out month,
  // the voucher PDF and the per-participant names.
  readonly columnPlanAutoSwitch = false;
  readonly profilePostCodeEnabled = false;
  readonly capacityNotice = false;
  readonly lastMonthSoldOut = false;
  readonly voucherPdf = false;
  readonly requireFormName = false;

  protected get siteApi() {
    return siteApi;
  }

  @computed
  get logoUrl() {
    return this.siteSchema?.siteLayout?.headerConfig?.logoUrl;
  }
}

export default new Site();
